var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button, InlineNotification, Text, TextInput } from '@ui';
import { connectionErrorMessage } from '../shared/connectionErrors';
import { FAILURE_REASONS } from '../shared/constants';
import { translatorFor } from '../shared/i18n';
import { errorResponse } from '../shared/types';
const t = translatorFor('connect_card');
export function ConnectCard({ onConnect }) {
    const [clientId, setClientId] = useState('');
    const [clientSecret, setClientSecret] = useState('');
    const [tenantId, setTenantId] = useState('');
    const [tenantIdRequired, setTenantIdRequired] = useState(false);
    const [connecting, setConnecting] = useState(false);
    const [error, setError] = useState(null);
    const canSubmit = clientId.trim() !== '' && clientSecret.trim() !== '' && (!tenantIdRequired || tenantId.trim() !== '');
    const submit = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        setConnecting(true);
        setError(null);
        try {
            yield onConnect(Object.assign({ clientId: clientId.trim(), clientSecret: clientSecret.trim() }, (tenantIdRequired ? { serviceTitanTenantId: tenantId.trim() } : {})));
        }
        catch (err) {
            const reason = (_a = errorResponse(err)) === null || _a === void 0 ? void 0 : _a.reason;
            if (reason === FAILURE_REASONS.TENANT_CLAIM_MISSING)
                setTenantIdRequired(true);
            setError(connectionErrorMessage(reason));
        }
        finally {
            setConnecting(false);
        }
    });
    return (React.createElement("section", { className: "service-titan-settings__card", "aria-labelledby": "service-titan-connect-title" },
        React.createElement(Text, { variant: "medium", as: "h2", id: "service-titan-connect-title" }, t('title')),
        React.createElement(Text, { variant: "body", as: "p", className: "service-titan-settings__muted" }, t('subtitle')),
        React.createElement("div", { className: "service-titan-settings__fields" },
            React.createElement(TextInput, { id: "service-titan-client-id", label: t('client_id_label'), required: true, value: clientId, onChange: (event) => setClientId(event.target.value) }),
            React.createElement(TextInput, { id: "service-titan-client-secret", type: "password", label: t('client_secret_label'), required: true, value: clientSecret, onChange: (event) => setClientSecret(event.target.value) }),
            tenantIdRequired && (React.createElement(TextInput, { id: "service-titan-tenant-id", label: t('tenant_id_label'), required: true, value: tenantId, onChange: (event) => setTenantId(event.target.value) }))),
        React.createElement(InlineNotification, { variant: "info", title: t('help_title') },
            React.createElement("ol", { className: "service-titan-settings__help-steps" },
                React.createElement("li", null, t('help_step_1')),
                React.createElement("li", null, t('help_step_2')),
                React.createElement("li", null, t('help_step_3'))),
            React.createElement(Text, { variant: "x-small", as: "p" }, t(tenantIdRequired ? 'tenant_id_help' : 'no_tenant_id_help'))),
        error && React.createElement(InlineNotification, { variant: "error" }, error),
        React.createElement("div", { className: "service-titan-settings__actions" },
            React.createElement(Button, { variant: "primary", disabled: !canSubmit || connecting, onClick: () => {
                    void submit();
                } }, connecting ? t('connecting') : t('connect')))));
}
export default ConnectCard;
